import { CaretRightIcon as CaretRight } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { cn } from '../../helpers/classBuilders';
import { PageRoute } from '../../types';

interface Props {
  routes: {
    routes: PageRoute;
    title?: string;
  }[];
}

export const Breadcrumb = ({ routes }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const stepperMenuRoutes = routes;

  const activePath = location.pathname;

  const isActiveRoute = (url: string) => activePath === url;

  const goToRoute = (url: string) => {
    if (isActiveRoute(url)) {
      return;
    }
    navigate(url);
  };

  return (
    <div className="bg-transparent flex flex-row p-0 [transform-style:preserve-3d] w-full text-sm">
      {stepperMenuRoutes.map((menuItem, index) => {
        const isActive = isActiveRoute(menuItem.routes.url);

        const breadcrumItemClassName = cn(
          'items-center text-[color:var(--inactive-menu)] cursor-pointer flex font-bold relative transition-all duration-200 ease-in select-none',
          {
            'text-[var(--color-brand-primary)]': isActive,
          },
        );

        return (
          <div key={`menuItems_${index}`} className="flex items-center">
            <div
              className={breadcrumItemClassName}
              onClick={() => goToRoute(menuItem.routes.url)}
            >
              {t(menuItem.title ? menuItem.title : menuItem.routes.displayName)}

              {stepperMenuRoutes.length === index + 1 ? (
                ''
              ) : (
                <span className="mx-[10px]">
                  <CaretRight weight="bold" size={10} />
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
